import { LEGACY_GBP_TO_PENCE_MULTIPLIER } from './legacyPriceConversion';

export const convertMicroCost = (microCost: number): string => {
  const cost = microCost / LEGACY_GBP_TO_PENCE_MULTIPLIER;

  // Format the cost to two decimal places only if necessary e.g. 1.00 should be 1, but 1.01 should be 1.01
  if (cost % 1 === 0) {
    return cost.toFixed(0);
  }
  return cost.toFixed(2);
};

export const convertMicroCostToLegacy = (microCost: number): number => {
  return microCost * LEGACY_GBP_TO_PENCE_MULTIPLIER;
};
